import { render, staticRenderFns } from "./MspForsageFolderForm.vue?vue&type=template&id=33889880&"
import script from "./MspForsageFolderForm.vue?vue&type=script&lang=js&"
export * from "./MspForsageFolderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports